import React from "react";
import PropTypes from "prop-types";
import Button from "../shared/button/Button";
import HiddenFormFields from "./HiddenFormFields";

const ChangePlanCheckout = (props) => {
  const {
    id,
    authenticityToken,
    buttonName,
    planClass,
    changePlanId,
    changePlanPath,
  } = props;
  const buttonClasses = "stripe-button-el btn subscription-link";

  return (
    <form
      className="edit_subscription"
      id={changePlanId}
      method="post"
      action={changePlanPath}
      acceptCharset="UTF-8"
      data-test-id="change-plan-form"
    >
      <HiddenFormFields authenticityToken={authenticityToken} />
      <input
        type="hidden"
        name="plan_class"
        id="plan_class"
        value={planClass}
      />
      <input type="hidden" name="plan_id" id="plan_id" value={id} />
      <Button
        primary
        classes={buttonClasses}
        buttonName={buttonName}
        dataTestId="checkout-button"
      />
    </form>
  );
};

ChangePlanCheckout.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  planClass: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  changePlanId: PropTypes.string,
  changePlanPath: PropTypes.string,
};

ChangePlanCheckout.defaultProps = {
  changePlanId: PropTypes.isNull,
  changePlanPath: PropTypes.isNull,
};

export default ChangePlanCheckout;
